<template style="height: 100%;">
  <div class="ReportDataMater-white">
    <el-container>
      <el-main>
        <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%;"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" v-if="ShowCheck" align="center"></el-table-column>
          <el-table-column label="序号" min-width="6%" align="center">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="UserID" label="学号" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="UserName" label="姓名" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="CreatedDate" label="评估时间" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="CreatorName" label="评估人" min-width="10%" align="center"></el-table-column>
          <el-table-column label="操作" min-width="15%" align="center">
            <template slot-scope="scope">
              <span @click="GoToCheckReport(scope.row)" class="rp-table_btn">
                查看记录
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="tableData.length > 0">
          <el-pagination :current-page.sync="pageIndex" :page-size="10" layout="total, prev, pager, next"
            :total="tableData.length">
          </el-pagination>
        </div>
      </el-main>
    </el-container>

    <el-dialog :title="dialogTitle" :visible.sync="isDialogShow" width="900px" :before-close="handleClose"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="dialog-content" :style="{ height: dialogHeight }">
        <tableconfig ref="tableconfig" class="table-config" :isTableNameVisible="true"
          @dialogHandleClose="handleClose" />
        <div class="tableconfig-creator" v-if="nowOption == 0"><span style="font-weight:bold;">评估人：</span>{{
            SelectItem.CreatorName
        }}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tableconfig from '../../components/my-table-config.vue'

export default {
  components: {
    tableconfig,
  },
  data() {
    return {
      nowOption: 0,
      dialogTitle: '新增记录',
      UserID: '',
      ID: '',
      ShowCheck: true,
      dialogHeight: '500px',
      TableCngID: '',
      ModuleID: '',
      tableData: [],
      pageIndex: 0,
      pageSize: 10,
      loading: false,
      isDialogShow: false,
      SelectedList: [],
      SelectItem: {}
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('fatherSetOption', 0)
      this.isDialogShow = false
      this.SelectItem = {}
      this.init()
    },
    SetTableConfig: function (item) {
      this.UserID = item.UserID
      this.TableCngID = item.TableConfigID
      this.ID = item.ID
      this.ModuleID = item.ModuleID
      this.ShowCheck = item.ShowCheck
      this.init()
    },
    init: function () {
      let parm = {
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        GeneralID: this.ID,
        TableConfigID: this.TableCngID,
        MenuID: this.ModuleID,
        UserID: this.UserID
      }
      this.loading = true
      let _this = this
      this.$Http_Post('ReportCriData/GetRPConRecordList', parm)
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.tableData = res.Data
            _this.loading = false
          } else {
            this.Global.request_failure(res.Message)
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          })
        })
    },
    DoMyAdd: function () {
      this.nowOption = 1
      this.dialogTitle = '新增记录'
      this.isDialogShow = true
      setTimeout(() => {
        this.$refs.tableconfig.init({
          OptionState: 1,
          TesterID: this.UserID,
          GeneralID: this.ID,
          TableCngID: this.TableCngID,
          Common: this.ModuleID,
          TableCngResultID: this.tableData.length > 0 ? this.tableData[0].TableCngResultID : ''
        })
      }, 100)
    },
    DoMyRemove: function () {
      if (this.SelectedList.length > 0) {
        this.$confirm('数据删除后将无法恢复, 是否继续?', '提示', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            let deleteList = []
            for (let i = 0; i < this.SelectedList.length; i++) {
              deleteList.push(this.SelectedList[i].TableCngResultID)
            }
            this.DeleteItems(deleteList)
          })
          .catch(() => { })
      } else this.Global.request_info('请选择要删除的数据')
    },
    DoMyModify: function () {
      if (this.SelectedList.length == 0) {
        this.$emit('fatherSetOption', 0)
        this.Global.request_info('请选择要修改的数据')
      }
      else if (this.SelectedList.length > 1) {
        this.$emit('fatherSetOption', 0)
        this.Global.request_info('只能选择一条数据修改')
      }
      else {
        this.nowOption = 2
        this.dialogTitle = '修改记录'
        this.isDialogShow = true
        setTimeout(() => {
          this.$refs.tableconfig.init({
            OptionState: 2,
            Common: this.ModuleID,
            TableCngID: this.TableCngID,
            TesterID: this.UserID,
            GeneralID: this.ID,
            TableCngResultID: this.SelectedList[0].TableCngResultID
          })
        }, 100)
      }
    },
    DeleteItems: function (itemList) {
      let _this = this
      this.$Http_Post('ReportCriData/DeleteRPConRecordList', {
        ItemList: itemList,
      })
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.Global.request_successful('删除成功!')
            _this.init()
          } else {
            this.Global.request_failure(res.Message)
          }
        })
        .catch((err) => {
          this.Global.request_failure(err.message)
        })
    },
    GoToCheckReport: function (item) {
      this.dialogTitle = '查看记录'
      this.nowOption = 0
      this.isDialogShow = true
      this.SelectItem = item
      setTimeout(() => {
        this.$refs.tableconfig.init({
          TableCngID: this.TableCngID,
          Common: this.ModuleID,
          OptionState: 0,
          TableCngResultID: item.TableCngResultID,
        })
      }, 100)
    },
    handleSelectionChange(val) {
      this.SelectedList = val
      if (this.SelectedList.length > 0) {
        this.$emit('SingleButton', { Name: 'btnRemove', Value: true })
      } else {
        this.$emit('SingleButton', { Name: 'btnRemove', Value: false })
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.dialogHeight =
        (document.documentElement.clientHeight * 0.65).toString() + 'px'
    })
  },
}
</script>
<style>
.dialogTable {
  height: 50%;
}

.tableconfig-creator {
  width: calc(100% - 50px);
  text-align: right;
  padding-right: 50px;
  margin-top: 20px;
  font-size: 16px;
}
</style>
